module.exports = "pegasus/assets/email1-company-logo2.png";